export const CLEAR_DELEGATIONS_IN_PROGRESS = "CLEAR_DELEGATIONS_IN_PROGRESS";
